import { AlertCircle, RefreshCw } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

interface SecuritiesErrorStateProps {
  message: string;
  onRetry?: () => void;
  /** Optional extra action, e.g. a "Go back" button. */
  action?: React.ReactNode;
}

/**
 * Reusable error state for securities pages.
 * Displays a destructive alert with an optional retry button.
 */
export function SecuritiesErrorState({ message, onRetry, action }: SecuritiesErrorStateProps) {
  return (
    <div className="space-y-4">
      <Alert variant="destructive" role="alert" aria-live="assertive">
        <AlertCircle className="h-4 w-4" aria-hidden="true" />
        <AlertDescription>{message}</AlertDescription>
      </Alert>
      <div className="flex gap-2">
        {onRetry && (
          <Button onClick={onRetry} variant="outline" aria-label="Retry loading data">
            <RefreshCw className="mr-2 h-4 w-4" aria-hidden="true" />
            Retry
          </Button>
        )}
        {action}
      </div>
    </div>
  );
}
